import { Button, Column } from '@upgrade/react-components';
import { mt } from '@upgrade/react-components/Spacing/core';
import styled from 'styled-components';

export const StyledVideoButton = styled(Button)`
  color: ${props => props.theme.palette.actionablePrimary};

  &:active,
  &:focus,
  &:hover {
    color: ${props => props.theme.palette.actionablePrimary};
  }

  @media (max-width: ${props => props.theme.mediaXs}) {
    white-space: normal;
  }
`;

export const StyledVideoButtonText = styled.span`
  color: ${props => props.theme.palette.content};
  line-height: 1rem;
`;

export const StyledVideoContainer = styled(Column)`
  ${mt('xl')}
`;
